var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore3Dots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6313_34416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99958 4.44448C11.2269 4.44448 12.2218 3.44955 12.2218 2.22224C12.2218 0.994931 11.2269 0 9.99958 0C8.77227 0 7.77734 0.994931 7.77734 2.22224C7.77734 3.44955 8.77227 4.44448 9.99958 4.44448Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99958 12.2218C11.2269 12.2218 12.2218 11.2269 12.2218 9.99958C12.2218 8.77227 11.2269 7.77734 9.99958 7.77734C8.77227 7.77734 7.77734 8.77227 7.77734 9.99958C7.77734 11.2269 8.77227 12.2218 9.99958 12.2218Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99958 20.0001C11.2269 20.0001 12.2218 19.0052 12.2218 17.7779C12.2218 16.5506 11.2269 15.5557 9.99958 15.5557C8.77227 15.5557 7.77734 16.5506 7.77734 17.7779C7.77734 19.0052 8.77227 20.0001 9.99958 20.0001Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6313_34416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore3Dots);
export default __webpack_public_path__ + "static/media/more_3_dots.7fd0ecc9.svg";
export { ForwardRef as ReactComponent };